import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PrintFinish } from '../prop-types';
import ButtonRibbon from '../../_utils/button-ribbon';

export default function PrintFinishTabs({ finishes, selectedFinish }) {
  if (!finishes.length) {
    return null;
  }

  return (
    <ButtonRibbon
      className="prints_builder-finish-tabs"
      role="tablist"
      gradient>
      <ul className="nav nav-tabs w-100 d-flex flex-nowrap mt-2 px-lg-3 px-sm-1">
        {finishes.map(({ title, name }) => {
          const active = name === selectedFinish?.name;
          // Append finish title to current URL params
          // Note: finish titles used in URL can contain reserved characters
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set('finish', title);
          const finishPath = `${window.location.pathname}?${searchParams
            .toString() // x-www-form-urlencode params
            .replace(/\+/g, '%20')}`; // convert space replacement + to %20

          return (
            <li
              className={classNames(
                'nav-item d-flex justify-content-center align-items-center text-nowrap mx-1',
                {
                  active: active,
                  'grey-zone': active,
                },
              )}
              onClick={() => (window.location.href = finishPath)}
              key={name}>
              {title}
            </li>
          );
        })}
      </ul>
    </ButtonRibbon>
  );
}

PrintFinishTabs.propTypes = {
  finishes: PropTypes.arrayOf(PrintFinish).isRequired,
  selectedFinish: PrintFinish,
};
